import React, { useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import styled from 'styled-components';

const { Option } = Select;

const StyledTitle = styled.h4`
  margin-bottom: 8px;
`;

const StyledEventSelectWrapper = styled.div`
  flex-shrink: 0;

  .not-valid {
    outline: solid red 1px;
  }
`;

const StyledSelect = styled(Select)`
  width: auto;
  min-width: 150px;
`;

const RetentionComposeEventSection = ({
  onEventChange,
  events,
  event,
  label,
  showNotValidFields = false,
}) => {
  const [isValid, setValid] = useState(true);

  useEffect(() => {
    if (showNotValidFields) {
      setValid(!!event);
    }
  }, [event, showNotValidFields]);

  const options = useMemo(() => {
    return [...events]
      .sort((a, b) => a.localeCompare(b))
      .map((e) => (
        <Option key={e} value={e}>
          {e}
        </Option>
      ));
  }, [events]);

  return (
    <>
      <StyledTitle>{label}</StyledTitle>
      <StyledEventSelectWrapper>
        <StyledSelect
          showSearch
          placeholder="Select an event"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          dropdownMatchSelectWidth
          dropdownStyle={{ width: 'auto' }}
          value={event || undefined}
          onSelect={(value) => onEventChange(value)}
          className={`ant-select-border-bottom ${isValid ? '' : 'not-valid'}`}
          getPopupContainer={(triggerNode) => triggerNode}
          virtual={false}
        >
          {options}
        </StyledSelect>
      </StyledEventSelectWrapper>
    </>
  );
};

export default RetentionComposeEventSection;
